/* eslint-disable */
import { Link, useLocation } from 'react-router-dom'
import { Breadcrumb as AntdBreadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

import menuItems from 'Components/Layout/Navigation/paths'
import { getArrayOfPaths } from 'Components/Layout/Navigation/utils'

import './Breadcrumb.less'

const findMenuItemByKey = (key) => {
  let found = null
  let foundParent = null
  let foundGrandParent = null

  menuItems.forEach((menuItem) => {
    if (menuItem.key === key) {
      found = menuItem
      return
    }
    if (menuItem.subitems) {
      menuItem.subitems.forEach((subitem) => {
        if (subitem.key === key) {
          found = subitem
          foundParent = menuItem
          return
        }
        if (subitem.subitems) {
          subitem.subitems.forEach((nestedItem) => {
            if (nestedItem.key === key) {
              found = nestedItem
              foundParent = subitem
              foundGrandParent = menuItem
            }
          })
        }
      })
    }
  })

  return { found, foundParent, foundGrandParent }
}

/**
 * Busca um item de menu pelo path completo
 */
const findMenuItemByPath = (path) => {
  let found = null
  let foundParent = null
  let foundGrandParent = null

  menuItems.forEach((menuItem) => {
    if (menuItem.path === path) {
      found = menuItem
      return
    }
    if (menuItem.subitems) {
      menuItem.subitems.forEach((subitem) => {
        if (subitem.path === path) {
          found = subitem
          foundParent = menuItem
          return
        }
        if (subitem.subitems) {
          subitem.subitems.forEach((nestedItem) => {
            if (nestedItem.path === path) {
              found = nestedItem
              foundParent = subitem
              foundGrandParent = menuItem
            }
          })
        }
      })
    }
  })

  return { found, foundParent, foundGrandParent }
}

/**
 * Verifica se a rota é uma ação de CRUD (create, update, edit)
 */
const isActionRoute = (segment) => {
  return ['create', 'update', 'edit'].includes(segment)
}

/**
 * Retorna o label apropriado para a ação
 */
const getActionLabel = (action, pathSegments) => {
  const actionLabels = {
    create: 'Criar',
    update: 'Editar',
    edit: 'Editar'
  }

  return actionLabels[action] || action
}

const Breadcrumb = () => {
  const location = useLocation()

  if (location.pathname === '/') {
    return (
      <AntdBreadcrumb className="breadcrumb__container">
        <AntdBreadcrumb.Item key="/">
          <Link to="/">
            <HomeOutlined />
          </Link>
        </AntdBreadcrumb.Item>
        <AntdBreadcrumb.Item key="dashboard">Dashboard</AntdBreadcrumb.Item>
      </AntdBreadcrumb>
    )
  }

  if (location.pathname === '/novidade') {
    return (
      <AntdBreadcrumb className="breadcrumb__container">
        <AntdBreadcrumb.Item key="/">
          <Link to="/">
            <HomeOutlined />
          </Link>
        </AntdBreadcrumb.Item>
        <AntdBreadcrumb.Item key="novidade">Novidades</AntdBreadcrumb.Item>
      </AntdBreadcrumb>
    )
  }

  const pathSegments = location.pathname.split('/').filter(Boolean)
  const lastSegment = pathSegments[pathSegments.length - 1]

  // Verifica se é uma rota de ação (create, update, edit) ou um ID numérico
  const isAction = isActionRoute(lastSegment)
  const isNumericId = !isNaN(lastSegment) && lastSegment.length > 0

  let found, foundParent, foundGrandParent, actionLabel

  if (isAction || isNumericId) {
    // Se for uma ação ou ID, busca o item pai pelo path sem os últimos segmentos
    let parentPathSegments, parentPath

    if (isNumericId) {
      // Para ID numérico, remove o ID e a ação (update/edit)
      parentPathSegments = pathSegments.slice(0, -2)
      parentPath = '/' + parentPathSegments.join('/')

      // Define o label da ação baseado no segmento anterior ao ID
      const actionSegment = pathSegments[pathSegments.length - 2]
      actionLabel = getActionLabel(actionSegment, pathSegments)
    } else {
      // Para ação direta (create), remove apenas o último segmento
      parentPathSegments = pathSegments.slice(0, -1)
      parentPath = '/' + parentPathSegments.join('/')
      actionLabel = getActionLabel(lastSegment, pathSegments)
    }

    // Tenta buscar pelo path completo
    const result = findMenuItemByPath(parentPath)
    found = result.found
    foundParent = result.foundParent
    foundGrandParent = result.foundGrandParent

    // Se não encontrou pelo path, tenta buscar pela última key do path pai
    if (!found) {
      const parentKey = parentPathSegments[parentPathSegments.length - 1]
      const keyResult = findMenuItemByKey(parentKey)
      found = keyResult.found
      foundParent = keyResult.foundParent
      foundGrandParent = keyResult.foundGrandParent
    }
  } else {
    // Lógica original para rotas normais
    const result = findMenuItemByKey(lastSegment)
    found = result.found
    foundParent = result.foundParent
    foundGrandParent = result.foundGrandParent
  }

  return (
    <AntdBreadcrumb className="breadcrumb__container">
      <AntdBreadcrumb.Item key="/">
        <Link to="/">
          <HomeOutlined />
        </Link>
      </AntdBreadcrumb.Item>

      {foundGrandParent && (
        <AntdBreadcrumb.Item key={foundGrandParent.key}>
          {foundGrandParent.label}
        </AntdBreadcrumb.Item>
      )}

      {foundParent && (
        <AntdBreadcrumb.Item key={foundParent.key}>
          {foundParent.label}
        </AntdBreadcrumb.Item>
      )}

      {found && (
        <AntdBreadcrumb.Item key={found.key}>{found.label}</AntdBreadcrumb.Item>
      )}

      {actionLabel && (
        <AntdBreadcrumb.Item key={`action-${lastSegment}`}>
          {actionLabel}
        </AntdBreadcrumb.Item>
      )}
    </AntdBreadcrumb>
  )
}

export default Breadcrumb
